import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const navHTML = `
<style>
@media (max-width: 991px) { 
    .desktop-nav { display: none !important; } 
    .header-inner-grid { grid-template-columns: 1fr !important; }
}
@media (min-width: 992px) { .menu-button { display: none !important; } }
</style>
<div class="page-wrapper"><div data-animation="default" data-collapse="all" data-duration="0" data-easing="ease" data-easing2="ease" role="banner" class="navbar w-nav"><div class="padding-global"><div class="container-large w-container"><div class="navbar-content-wrapper"><a href="/" class="logo-link w-nav-brand w--current" aria-label="home"><div style="font-size: 1.25rem; font-weight: 700; color: #274c77; letter-spacing: -0.02em;">CA Ronak Patel</div></a><div class="desktop-nav" style="display: flex; gap: 2.5rem; align-items: center;"><a href="/" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">Home</a><a href="/#services" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">Services</a><a href="/#software" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">Software</a><a href="/#faq" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">FAQ</a><a href="/#contact" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">Contact</a><a href="/login" style="background-color: #274c77; color: white; padding: 0.5rem 1.25rem; border-radius: 0.5rem; font-weight: 600; text-decoration: none; transition: background-color 0.2s;" onMouseOver="this.style.backgroundColor='#1a365d'" onMouseOut="this.style.backgroundColor='#274c77'">Login</a></div><nav id="mobile-nav" role="navigation" class="nav-menu w-nav-menu" style="display: none; background-color: #e2e8f0; position: absolute; top: 100%; left: 0; width: 100%; z-index: 1000;"><div class="nav-menu-container" style="opacity: 1; height: auto; min-height: 100vh; padding-top: 5vh; gap: 1rem;"><a href="/" onclick="document.getElementById('mobile-nav').style.display='none'" aria-current="page" class="nav-link w-inline-block w--current"><div>Home</div></a><a href="/#services" onclick="document.getElementById('mobile-nav').style.display='none'" class="nav-link w-inline-block"><div>Services</div></a><a href="/#software" onclick="document.getElementById('mobile-nav').style.display='none'" class="nav-link w-inline-block"><div>Software</div></a><a href="/#faq" onclick="document.getElementById('mobile-nav').style.display='none'" class="nav-link w-inline-block"><div>FAQ</div></a><a href="/#contact" onclick="document.getElementById('mobile-nav').style.display='none'" class="nav-link w-inline-block"><div>Contact</div></a><a href="/login" class="nav-link w-inline-block" style="background-color: #274c77; color: white; padding: 0.5rem 1.25rem; border-radius: 0.5rem; width: auto; margin-top: 1rem;"><div style="color: white; text-align: center;">Login</div></a></div></nav><div onclick="var nav = document.getElementById('mobile-nav'); if(nav.style.display === 'none'){nav.style.display = 'flex';}else{nav.style.display = 'none';}" class="menu-button w-nav-button" style="-webkit-user-select: text;" aria-label="menu" role="button" tabindex="0" aria-controls="w-nav-overlay-0" aria-haspopup="menu" aria-expanded="false"><div class="inner-menu-button"><div class="menu-line-container"><div class="menu-line-wrap"><div class="top-dash"></div></div><div class="menu-line-wrap"><div class="middle-dash"></div></div><div class="menu-line-wrap"><div class="bottom-dash"></div></div></div></div></div></div></div></div></div><div class="w-nav-overlay" data-wf-ignore="" id="w-nav-overlay-0"></div></div>`;

const footerHTML = `<footer class="footer"><div class="padding-global"><div class="w-layout-blockcontainer container-large w-container"><div class="footer-padding"><div class="footer-bottom-wrapper"><div class="footer-link-block"><div class="footer_credit-text">Designed for CA Ronak Patel</div><div class="footer_credit-text">All Rights Reserved © 2026</div></div><div class="footer-link-block"><a href="/privacy-policy" class="footer-legal-link">Privacy Policy</a><a href="/terms-of-service" class="footer-legal-link">Terms of Service</a></div></div></div></div></div></footer>`;

const EFFECTIVE_DATE = "7 June 2026";
const PRACTICE_NAME = "CA Ronak Patel (Chartered Accountant)";
const CONTACT_EMAIL = "notifications@caronakpatel.com";

const sectionH2Style = { fontSize: "1.35rem", fontWeight: "700", color: "#274c77", marginBottom: "0.75rem" };
const listStyle = { paddingLeft: "1.5rem", marginTop: "0.75rem", listStyleType: "disc", display: "flex", flexDirection: "column", gap: "0.5rem" };

const sections = [
  {
    id: "agreement",
    title: "1. Agreement to Terms",
    content: (
      <>
        <p>These Terms of Service ("Terms") constitute a legally binding agreement between you ("User," "Client," "you," "your") and <strong>{PRACTICE_NAME}</strong> ("Practice," "we," "our," "us") governing your access to and use of the website <strong>caronakpatel.com</strong> and all associated client portal services (collectively, the "Platform").</p>
        <p style={{ marginTop: "1rem" }}>By accessing the Platform, registering an account, uploading documents, or engaging any service, you confirm that you:</p>
        <ul style={listStyle}>
          <li>Have read, understood, and agreed to be bound by these Terms in their entirety;</li>
          <li>Are at least 18 years of age (or the age of majority in your jurisdiction);</li>
          <li>Have the legal authority to enter into this agreement on behalf of yourself or the entity you represent;</li>
          <li>Agree to comply with all applicable local, national, and international laws and regulations.</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>If you do not agree with any part of these Terms, you must immediately cease use of the Platform. These Terms shall be read alongside our <a href="/privacy-policy" style={{ color: "#145886" }}>Privacy Policy</a>, which is incorporated herein by reference.</p>
      </>
    ),
  },
  {
    id: "services",
    title: "2. Description of Services",
    content: (
      <>
        <p>The Platform provides a secure, virtual environment through which the Practice delivers the following professional services:</p>
        <ul style={listStyle}>
          <li><strong>Accounting & Bookkeeping:</strong> Cloud-based end-to-end bookkeeping, financial statement preparation, ledger maintenance, and chart-of-accounts management for businesses and individuals.</li>
          <li><strong>Income Tax Consultation & ITR Filing:</strong> Tax advisory, computation of tax liability, and filing of Income Tax Returns (ITRs) for Resident Individuals, Non-Resident Indians (NRIs), Firms, and Businesses under the Income Tax Act, 1961.</li>
          <li><strong>GST Compliance:</strong> GST registration, return filing (GSTR-1, GSTR-3B, etc.), reconciliation, and advisory under the CGST Act, 2017.</li>
          <li><strong>Offshore & International Accounting:</strong> Bookkeeping and financial reporting for clients in international jurisdictions using cloud accounting platforms (Xero, QuickBooks, Zoho Books, Tally).</li>
          <li><strong>Client Document Portal:</strong> A secure, encrypted vault for uploading, storing, and sharing financial documents.</li>
          <li><strong>Communication & Advisory:</strong> Secure messaging and video consultation services for professional advisory.</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>Services are delivered <strong>100% virtually and remotely</strong>. No in-person meetings are guaranteed unless separately arranged.</p>
        <p style={{ marginTop: "1rem" }}>The specific scope of services, fees, timelines, and deliverables for each engagement shall be documented in a separate <strong>Engagement Letter</strong> or <strong>Service Agreement</strong>, which shall take precedence over these Terms in the event of conflict for that specific engagement.</p>
      </>
    ),
  },
  {
    id: "account",
    title: "3. Account Registration & Security",
    content: (
      <>
        <p>To access the client portal, you must register an account. By registering, you agree to:</p>
        <ul style={listStyle}>
          <li>Provide accurate, current, and complete information during registration and to keep it updated;</li>
          <li>Maintain the confidentiality of your login credentials (password, OTP, or OAuth tokens);</li>
          <li>Be solely responsible for all activities that occur under your account;</li>
          <li>Notify us immediately at <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: "#145886" }}>{CONTACT_EMAIL}</a> of any unauthorised access or security breach;</li>
          <li>Not share account credentials with third parties or use another person's account without authorisation.</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>We support authentication via <strong>Google OAuth 2.0</strong>. When using Google Sign-In, you also agree to comply with Google's Terms of Service and Privacy Policy. We are not responsible for the security practices of Google or any third-party identity provider.</p>
        <p style={{ marginTop: "1rem" }}>We reserve the right to suspend or terminate accounts that appear compromised, are involved in fraudulent activity, or violate these Terms, with or without prior notice.</p>
      </>
    ),
  },
  {
    id: "client-obligations",
    title: "4. Client Obligations & Representations",
    content: (
      <>
        <p>By using the Platform and engaging our services, you represent, warrant, and undertake that:</p>
        <ul style={listStyle}>
          <li>All information, documents, and data you provide to us (including financial records, bank statements, invoices, and identity documents) are <strong>true, accurate, complete, and not misleading</strong>;</li>
          <li>You are authorised to submit the data and documents on behalf of the entity or individual whose accounts are being managed;</li>
          <li>You will cooperate promptly with our requests for information, clarification, or documentation necessary for service delivery;</li>
          <li>You will comply with all applicable laws in your jurisdiction, including tax laws, company laws, foreign exchange regulations (FEMA), anti-money laundering laws (PMLA), and any regulations governing the subject matter of our engagement;</li>
          <li>You will not use the Platform to upload, transmit, or store any content that is unlawful, fraudulent, defamatory, obscene, or in violation of any third-party intellectual property rights;</li>
          <li>You will not attempt to gain unauthorised access to any part of the Platform, its servers, databases, or associated systems;</li>
          <li>You will not use automated tools (bots, scrapers, crawlers) to access or extract data from the Platform;</li>
          <li>You are aware that professional advisory services rendered through this Platform are subject to professional standards and regulations of the ICAI and applicable law.</li>
        </ul>
        <p style={{ marginTop: "1rem" }}><strong>Consequence of Breach:</strong> Providing false or misleading information may result in immediate termination of services, forfeiture of fees paid, and may expose you to civil and criminal liability under applicable laws including Sections 277, 278 of the Income Tax Act, 1961; the Indian Penal Code / BNS; and applicable foreign laws.</p>
      </>
    ),
  },
  {
    id: "professional-disclaimer",
    title: "5. Nature of Professional Services & Disclaimer",
    content: (
      <>
        <p>Our services constitute professional accounting and tax advisory services rendered by a Chartered Accountant registered with the <strong>Institute of Chartered Accountants of India (ICAI)</strong>. The following apply:</p>
        <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem", marginTop: "1rem" }}>
          {[
            {
              title: "Not Legal Advice",
              desc: "Nothing on this Platform constitutes legal advice. For legal matters, consult a qualified advocate or solicitor."
            },
            {
              title: "Reliance on Client Information",
              desc: "Our advice and filings are based on the information and documents provided by you. We are not responsible for errors or omissions arising from incomplete, inaccurate, or misleading information provided by the client."
            },
            {
              title: "Regulatory Changes",
              desc: "Tax laws, GST regulations, and accounting standards are subject to change. We endeavour to stay current but cannot guarantee that all information on the Platform reflects the latest regulatory changes in real time."
            },
            {
              title: "No Guarantee of Outcomes",
              desc: "We do not guarantee any specific tax savings, assessment outcomes, refund amounts, or approval of any filings by government authorities. Regulatory decisions are at the sole discretion of the relevant authorities."
            },
            {
              title: "Concurrent Jurisdiction",
              desc: "For clients in multiple jurisdictions, our advisory is primarily India-focused. For foreign tax matters, local advisors in the relevant jurisdiction should be engaged."
            },
          ].map((item) => (
            <div key={item.title} style={{ background: "#f8fafc", padding: "0.8rem 1rem", borderRadius: "0.5rem", borderLeft: "3px solid #f28f3b" }}>
              <p><strong>{item.title}:</strong> {item.desc}</p>
            </div>
          ))}
        </div>
      </>
    ),
  },
  {
    id: "fees",
    title: "6. Fees, Payments & Refunds",
    content: (
      <>
        <p>Fees for our services are as agreed in the applicable Engagement Letter or as displayed on the Platform at the time of purchase.</p>
        <ul style={listStyle}>
          <li><strong>Payment Terms:</strong> Fees are payable in advance or as per milestones specified in the Engagement Letter. We accept payments via bank transfer, UPI, and approved online payment gateways.</li>
          <li><strong>GST:</strong> All fees are exclusive of Goods and Services Tax (GST) unless expressly stated. GST at the applicable rate will be charged additionally for services provided in India.</li>
          <li><strong>Foreign Currency:</strong> For international clients, fees may be quoted in INR, USD, AUD, GBP, or EUR as agreed. Exchange rate fluctuations are the client's risk.</li>
          <li><strong>Late Payment:</strong> We reserve the right to suspend service delivery for overdue invoices and charge interest at the rate of 1.5% per month on outstanding amounts.</li>
          <li><strong>Refund Policy:</strong> Fees paid for services already commenced or delivered are generally non-refundable. Refunds for unstarted services may be considered on a case-by-case basis at our sole discretion, net of any administrative charges incurred.</li>
          <li><strong>Disputed Invoices:</strong> Any invoice disputes must be raised in writing within 7 days of the invoice date, failing which the invoice shall be deemed accepted.</li>
        </ul>
      </>
    ),
  },
  {
    id: "ip",
    title: "7. Intellectual Property Rights",
    content: (
      <>
        <p>All content on the Platform — including but not limited to website design, source code, graphics, logos, text, templates, methodologies, and analytical frameworks ("Platform Content") — is the proprietary property of {PRACTICE_NAME} or its licensors and is protected by applicable intellectual property laws including the <strong>Copyright Act, 1957 (India)</strong> and international copyright treaties.</p>
        <p style={{ marginTop: "1rem" }}>You are granted a limited, non-exclusive, non-transferable, revocable licence to access and use the Platform solely for the purposes of availing the services described herein. You must not:</p>
        <ul style={listStyle}>
          <li>Copy, reproduce, or distribute any Platform Content without prior written consent;</li>
          <li>Reverse-engineer, decompile, or disassemble any software components of the Platform;</li>
          <li>Use Platform Content to develop a competing service;</li>
          <li>Remove any copyright, trademark, or proprietary notices from the Platform.</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>Your documents and data uploaded to the Platform remain your intellectual property. By uploading them, you grant us a limited licence to access and process them solely for the purpose of delivering the contracted services.</p>
      </>
    ),
  },
  {
    id: "confidentiality",
    title: "8. Confidentiality",
    content: (
      <>
        <p>Given the nature of professional accounting services, both parties acknowledge the sensitivity of the information exchanged. We are bound by:</p>
        <ul style={listStyle}>
          <li>The <strong>ICAI Code of Ethics</strong> relating to confidentiality of client information;</li>
          <li>The <strong>Digital Personal Data Protection Act, 2023</strong> (India);</li>
          <li>Our Privacy Policy, incorporated herein by reference;</li>
          <li>Any applicable Engagement Letter confidentiality provisions.</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>We will not disclose your confidential information to any third party except: (a) with your express consent; (b) as required by law or regulatory authority; (c) to authorised service providers acting under our instruction and bound by equivalent confidentiality obligations.</p>
        <p style={{ marginTop: "1rem" }}>You similarly agree to maintain the confidentiality of any proprietary methodologies, templates, reports, or advisory materials we provide to you, and not to share them with unauthorised third parties.</p>
      </>
    ),
  },
  {
    id: "data-handling",
    title: "9. Data Handling & Document Security",
    content: (
      <>
        <p>All documents and financial data uploaded to the Platform are:</p>
        <ul style={listStyle}>
          <li>Encrypted using <strong>AES-256</strong> encryption at rest and <strong>TLS 1.3</strong> in transit;</li>
          <li>Stored on secure cloud infrastructure protected by Cloudflare's WAF and DDoS mitigation;</li>
          <li>Accessible only to authorised personnel on a need-to-know basis;</li>
          <li>Subject to our full Privacy Policy for collection, use, retention, and deletion.</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>You are responsible for ensuring that all documents uploaded do not infringe third-party rights and comply with applicable export control or data localisation regulations of your jurisdiction.</p>
        <p style={{ marginTop: "1rem" }}>We maintain financial records in accordance with statutory retention requirements (generally 8 years for income tax and GST records under Indian law). For detailed data retention schedules, refer to our <a href="/privacy-policy#retention" style={{ color: "#145886" }}>Privacy Policy – Section 8</a>.</p>
      </>
    ),
  },
  {
    id: "liability",
    title: "10. Limitation of Liability",
    content: (
      <>
        <p>To the maximum extent permitted by applicable law:</p>
        <ul style={listStyle}>
          <li>The Platform is provided on an <strong>"as is"</strong> and <strong>"as available"</strong> basis without warranties of any kind, whether express or implied, including merchantability, fitness for a particular purpose, or non-infringement;</li>
          <li>We shall not be liable for any <strong>indirect, incidental, special, consequential, or punitive damages</strong>, including loss of profits, data, goodwill, or business opportunities, arising from your use of or inability to use the Platform;</li>
          <li>Our aggregate liability to you for any claims arising out of or related to these Terms or the services shall not exceed the <strong>total fees paid by you to us in the three (3) months immediately preceding the event giving rise to the claim</strong>;</li>
          <li>We are not liable for losses arising from: errors in client-provided information; regulatory changes; system failures of third-party platforms (Xero, Zoho, QuickBooks, etc.); force majeure events; or actions of government authorities.</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>Nothing in these Terms shall limit or exclude our liability for fraud, death or personal injury caused by our negligence, or any liability that cannot be limited by applicable law.</p>
        <p style={{ marginTop: "1rem" }}><strong>Consumer Rights:</strong> If you are a consumer under applicable consumer protection laws (Consumer Protection Act, 2019 – India; Consumer Rights Act 2015 – UK; or equivalent), your statutory rights are not affected by this clause.</p>
      </>
    ),
  },
  {
    id: "indemnification",
    title: "11. Indemnification",
    content: (
      <>
        <p>You agree to indemnify, defend, and hold harmless {PRACTICE_NAME}, its principals, affiliates, employees, agents, and successors from and against any claims, liabilities, damages, losses, costs, or expenses (including reasonable legal fees) arising out of or relating to:</p>
        <ul style={listStyle}>
          <li>Your breach of these Terms or the Privacy Policy;</li>
          <li>Your violation of any applicable law or regulation;</li>
          <li>False, inaccurate, or misleading information provided by you;</li>
          <li>Your infringement of any third-party rights (intellectual property, privacy, or otherwise);</li>
          <li>Any unauthorised use of your account;</li>
          <li>Any tax liability, penalty, or interest arising from regulatory non-compliance on your part.</li>
        </ul>
      </>
    ),
  },
  {
    id: "termination",
    title: "12. Term, Termination & Suspension",
    content: (
      <>
        <p><strong>Term:</strong> These Terms remain in effect for as long as you maintain an account or engage services on the Platform.</p>
        <p style={{ marginTop: "1rem" }}><strong>Termination by You:</strong> You may close your account at any time by written notice to us at <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: "#145886" }}>{CONTACT_EMAIL}</a>. Closure does not relieve you of outstanding fee obligations.</p>
        <p style={{ marginTop: "1rem" }}><strong>Termination by Us:</strong> We may suspend or terminate your account and access to the Platform, with or without notice, if:</p>
        <ul style={listStyle}>
          <li>You breach any provision of these Terms;</li>
          <li>You fail to pay fees when due;</li>
          <li>You engage in fraudulent, illegal, or unethical conduct;</li>
          <li>Continuation of services would expose us to legal, professional, or reputational risk;</li>
          <li>Required by applicable law or a regulatory authority.</li>
        </ul>
        <p style={{ marginTop: "1rem" }}><strong>Effect of Termination:</strong> Upon termination, your right to access the Platform ceases. We will retain your data for the periods required by law (as set out in the Privacy Policy) and then securely delete it. You may request a copy of your data before deletion.</p>
        <p style={{ marginTop: "1rem" }}>Sections 7 (Intellectual Property), 8 (Confidentiality), 10 (Limitation of Liability), 11 (Indemnification), 13 (Governing Law), and 14 (Dispute Resolution) survive termination.</p>
      </>
    ),
  },
  {
    id: "governing-law",
    title: "13. Governing Law & Jurisdiction",
    content: (
      <>
        <p>These Terms shall be governed by and construed in accordance with the laws of <strong>India</strong>, without regard to its conflict of law principles. The courts of <strong>India</strong> shall have exclusive jurisdiction over any disputes arising out of or in connection with these Terms, subject to the arbitration provisions below.</p>
        <p style={{ marginTop: "1rem" }}>For clients in specific jurisdictions, the following mandatory consumer protections additionally apply:</p>
        <ul style={listStyle}>
          <li><strong>EU/EEA Residents:</strong> You may also have the right to bring claims before the courts or consumer dispute resolution bodies in your country of residence under EU consumer protection law.</li>
          <li><strong>UK Residents:</strong> Nothing in these Terms affects your rights under UK consumer protection legislation.</li>
          <li><strong>Australian Residents:</strong> Australian Consumer Law guarantees that cannot be excluded apply to you.</li>
          <li><strong>US Residents:</strong> For California residents, nothing in these Terms limits rights available under the CCPA/CPRA.</li>
        </ul>
      </>
    ),
  },
  {
    id: "dispute",
    title: "14. Dispute Resolution",
    content: (
      <>
        <p><strong>Step 1 – Informal Resolution:</strong> Before initiating any formal proceedings, the parties agree to attempt resolution of any dispute through good-faith negotiation. Either party may initiate this process by written notice to the other.</p>
        <p style={{ marginTop: "1rem" }}><strong>Step 2 – Mediation:</strong> If the dispute is not resolved within 30 days of the written notice, the parties agree to attempt mediation through a mutually agreed mediator.</p>
        <p style={{ marginTop: "1rem" }}><strong>Step 3 – Arbitration:</strong> If mediation fails, any dispute, controversy, or claim arising out of or relating to these Terms shall be referred to and finally resolved by <strong>arbitration</strong> in accordance with the <strong>Arbitration and Conciliation Act, 1996 (India)</strong>, as amended. The arbitration shall be conducted by a sole arbitrator mutually appointed by the parties. The seat and venue of arbitration shall be in India. The language of arbitration shall be English.</p>
        <p style={{ marginTop: "1rem" }}><strong>Step 4 – Courts:</strong> If arbitration is not applicable or the Arbitration Act does not permit arbitration for the specific matter, the parties submit to the exclusive jurisdiction of the competent courts in India.</p>
        <p style={{ marginTop: "1rem" }}>Notwithstanding the above, either party may seek emergency injunctive relief from a competent court without prejudice to the arbitration agreement.</p>
        <p style={{ marginTop: "1rem" }}><strong>Consumer Disputes (India):</strong> Clients who are consumers under the Consumer Protection Act, 2019 may also approach the appropriate Consumer Disputes Redressal Commission.</p>
      </>
    ),
  },
  {
    id: "prohibited",
    title: "15. Prohibited Uses",
    content: (
      <>
        <p>You expressly agree that you will not use the Platform for any of the following purposes:</p>
        <ul style={listStyle}>
          <li>Money laundering, tax evasion, or any activity that violates the Prevention of Money Laundering Act (PMLA), 2002, FEMA, or equivalent foreign laws;</li>
          <li>Submitting fraudulent documents, forged signatures, or fabricated financial records;</li>
          <li>Impersonating any person or entity;</li>
          <li>Uploading malware, viruses, or any malicious code;</li>
          <li>Attempting to breach or circumvent the Platform's security measures;</li>
          <li>Engaging in any activity that would violate professional standards applicable to the Chartered Accountancy profession;</li>
          <li>Using the Platform to harass, intimidate, or harm any individual;</li>
          <li>Violating any applicable export control, sanctions, or trade restriction laws.</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>Violation of these prohibitions may result in immediate account termination, reporting to appropriate authorities, and civil or criminal legal action.</p>
      </>
    ),
  },
  {
    id: "force-majeure",
    title: "16. Force Majeure",
    content: (
      <>
        <p>We shall not be liable for any failure or delay in performing our obligations under these Terms or any Engagement Letter where such failure or delay results from circumstances beyond our reasonable control, including but not limited to:</p>
        <ul style={listStyle}>
          <li>Acts of God, natural disasters, pandemics, or epidemics;</li>
          <li>War, terrorism, civil unrest, or governmental actions;</li>
          <li>Internet or telecommunications failures, cyberattacks, or third-party platform outages;</li>
          <li>Changes in law or regulatory requirements that prevent performance;</li>
          <li>National or regional lockdowns or mobility restrictions.</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>In such events, we will notify you as soon as reasonably practicable and will resume performance as soon as the force majeure event ceases. Statutory deadlines (e.g., ITR filing due dates set by the Income Tax Department) remain the client's responsibility to monitor.</p>
      </>
    ),
  },
  {
    id: "accessibility",
    title: "17. Accessibility & Platform Availability",
    content: (
      <>
        <p>We endeavour to maintain Platform availability 24/7 but do not guarantee uninterrupted access. Planned maintenance windows will be communicated in advance where possible.</p>
        <p style={{ marginTop: "1rem" }}>We are committed to making the Platform reasonably accessible in accordance with international web accessibility guidelines (WCAG 2.1). If you encounter accessibility barriers, please notify us at <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: "#145886" }}>{CONTACT_EMAIL}</a>.</p>
      </>
    ),
  },
  {
    id: "modifications",
    title: "18. Modifications to Terms",
    content: (
      <>
        <p>We reserve the right to modify these Terms at any time. When we make material changes, we will:</p>
        <ul style={listStyle}>
          <li>Update the "Effective Date" at the top of this document;</li>
          <li>Post a prominent notice on the Platform;</li>
          <li>Send an email notification to registered users where required by applicable law.</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>Your continued use of the Platform after the effective date of revised Terms constitutes your acceptance of the changes. If you disagree, you must discontinue use and may request account closure.</p>
      </>
    ),
  },
  {
    id: "general",
    title: "19. General Provisions",
    content: (
      <>
        <ul style={listStyle}>
          <li><strong>Entire Agreement:</strong> These Terms, together with the Privacy Policy and any applicable Engagement Letter, constitute the entire agreement between you and us and supersede all prior agreements, representations, or understandings.</li>
          <li><strong>Severability:</strong> If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions shall continue in full force and effect.</li>
          <li><strong>Waiver:</strong> Our failure to enforce any right or provision of these Terms shall not constitute a waiver of future enforcement of that right or provision.</li>
          <li><strong>Assignment:</strong> You may not assign your rights or obligations under these Terms without our prior written consent. We may assign our rights in connection with a merger, acquisition, or sale of assets.</li>
          <li><strong>No Agency:</strong> Nothing in these Terms creates a partnership, joint venture, agency, or employment relationship between the parties.</li>
          <li><strong>Language:</strong> These Terms are executed in the English language, which shall be the authoritative version. Translations, if any, are provided for convenience only.</li>
          <li><strong>Notices:</strong> All formal notices must be in writing and sent to the email addresses specified herein. Notice is deemed given when email is received without a bounce notification.</li>
        </ul>
      </>
    ),
  },
  {
    id: "contact",
    title: "20. Contact Information",
    content: (
      <>
        <p>For any questions, concerns, or disputes regarding these Terms of Service, please contact us:</p>
        <div style={{ background: "#f1f5f9", borderLeft: "4px solid #274c77", padding: "1rem 1.5rem", borderRadius: "0 0.5rem 0.5rem 0", marginTop: "1rem" }}>
          <p><strong>CA Ronak Patel</strong></p>
          <p><strong>Designation:</strong> Chartered Accountant (ICAI Registered)</p>
          <p><strong>Email:</strong> <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: "#145886" }}>{CONTACT_EMAIL}</a></p>
          <p><strong>Platform:</strong> caronakpatel.com</p>
          <p><strong>Response Time:</strong> Within 5 business days for general enquiries; within 30 calendar days for formal legal notices.</p>
        </div>
      </>
    ),
  },
];

export default function TermsofService() {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    const navbar = document.querySelector(".navbar");
    if (navbar) {
      const links = navbar.querySelectorAll("a");
      links.forEach((link) => {
        link.addEventListener("click", (e) => {
          const href = link.getAttribute("href");
          if (!href || href.startsWith("http")) return;
          e.preventDefault();
          if (href === "/" || href === "#") {
            navigate("/");
          } else if (href.startsWith("/#")) {
            const targetId = href.split("#")[1];
            navigate("/");
            setTimeout(() => {
              const el = document.getElementById(targetId);
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }, 150);
          } else {
            navigate(href);
          }
        });
      });
    }
  }, [navigate]);

  return (
    <div style={{ backgroundColor: "#e2e8f0", minHeight: "100vh" }}>
      <div dangerouslySetInnerHTML={{ __html: navHTML }} />
      <main className="main-wrapper">
        <section className="section" style={{ paddingTop: "6rem", paddingBottom: "4rem" }}>
          <div className="padding-global">
            <div className="w-layout-blockcontainer container-large w-container">

              {/* Header */}
              <div className="shadow-box medium-padding" style={{ marginBottom: "2rem", background: "linear-gradient(135deg, #145886 0%, #1e3a5f 100%)", color: "white", borderRadius: "1rem", padding: "2.5rem" }}>
                <h1 style={{ color: "white", fontSize: "2.5rem", fontWeight: "800", marginBottom: "0.5rem" }}>Terms of Service</h1>
                <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "1rem" }}>
                  <strong>Effective Date:</strong> {EFFECTIVE_DATE} &nbsp;|&nbsp;
                  <strong>Governing Law:</strong> India (Arbitration & Conciliation Act, 1996)
                </p>
                <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.9rem", marginTop: "0.5rem" }}>
                  Applicable to: All Platform users globally &nbsp;|&nbsp; ICAI-registered Professional Services
                </p>
              </div>

              {/* Important Notice */}
              <div style={{ background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: "0.75rem", padding: "1.25rem 1.5rem", marginBottom: "2rem" }}>
                <p style={{ color: "#991b1b", fontSize: "0.95rem" }}>
                  <strong>⚠️ Please Read Carefully:</strong> These Terms constitute a legally binding contract. By using this Platform or engaging our services, you agree to these Terms. If you are engaging on behalf of a company or organisation, you confirm you have authority to bind that entity.
                </p>
              </div>

              {/* TOC */}
              <div className="shadow-box medium-padding" style={{ marginBottom: "2rem", padding: "1.5rem" }}>
                <h2 style={{ ...sectionH2Style, marginBottom: "1rem", fontSize: "1.1rem" }}>Table of Contents</h2>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "0.4rem" }}>
                  {sections.map((s) => (
                    <a
                      key={s.id}
                      href={`#${s.id}`}
                      style={{ color: "#145886", textDecoration: "none", fontSize: "0.9rem", padding: "0.2rem 0", display: "block" }}
                      onMouseOver={(e) => e.target.style.textDecoration = "underline"}
                      onMouseOut={(e) => e.target.style.textDecoration = "none"}
                    >
                      {s.title}
                    </a>
                  ))}
                </div>
              </div>

              {/* Sections */}
              {sections.map((s) => (
                <div
                  key={s.id}
                  id={s.id}
                  className="shadow-box medium-padding"
                  style={{ marginBottom: "1.5rem", padding: "2rem", textAlign: "left", scrollMarginTop: "6rem" }}
                >
                  <h2 style={sectionH2Style}>{s.title}</h2>
                  <div style={{ color: "#475569", lineHeight: "1.8", fontSize: "1rem" }}>
                    {s.content}
                  </div>
                </div>
              ))}

              {/* Footer Disclaimer */}
              <div style={{ background: "#fef9c3", border: "1px solid #fbbf24", borderRadius: "0.75rem", padding: "1.25rem 1.5rem", marginBottom: "2rem" }}>
                <p style={{ color: "#92400e", fontSize: "0.9rem" }}>
                  <strong>⚠️ Legal Disclaimer:</strong> These Terms of Service are prepared in good faith and reflect the standard terms of engagement of this professional practice. They are not a substitute for a formal, jurisdiction-specific legal review. Clients with specific legal requirements are advised to consult a qualified solicitor or advocate before engaging services.
                </p>
              </div>

            </div>
          </div>
        </section>
      </main>
      <div dangerouslySetInnerHTML={{ __html: footerHTML }} />
    </div>
  );
}
